import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { PXFormModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper';
import WizardStepDeleteButton from 'Views/Page/Content/Modal/Layouts/DefaultFDWizardStep/Layout/WizardStepDeleteButton';
import {
  FDBox, FDPrimaryActionButton,
} from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { FileViewer } from 'Components/ComponentLibrary/Components/Uncategorized/FileViewer';
import { addQueryWithReplace } from 'Helpers/Query';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import {
  AltAllocationMessageContainer,
} from 'Views/Page/Content/Modal/Layouts/AltAllocationMessage/AltAllocationMessageContainer';
import {
  AltAllocationMessageProvider,
} from 'Views/Page/Content/Modal/Layouts/AltAllocationMessage/AltAllocationMessageContext';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  async function handleDelete() {
    let resp;
    try {
      resp = await resource.delete();
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Error: Failed to delete');
      }
    }

    return resp;
  }

  const onDeleteSuccess = async () => {
    clearModalCollection();
    refreshPageContentCollection();
  };

  const accountStatements = resource.attr('accountStatements')?.resources();

  const hasAltIncomeModelAttribute = resource.attr('modelAttribute') === 'alternative-income';

  return (
    <PXFormModalWrapper>
      <MetaControlField attr={'accountType'} />
      <MetaControlField attr={'accountSubType'} />
      <MetaControlField attr={'name'} />
      <MetaControlField attr={'ownerTypeId'} />
      <MetaControlField attr={'accountOwnerNotes'} />
      <MetaLayoutRemainingFields expanded />
      <MetaControlField attr="alternativeIncomeAllocationPercentage" />
      {hasAltIncomeModelAttribute && resource.withRelationship(fr.relationships.altAllocationMessage.name,
        (rel) => (
          <AltAllocationMessageProvider>
            <AltAllocationMessageContainer relationship={rel} />
          </AltAllocationMessageProvider>
        ),
        () => null)}
      {accountStatements?.length() > 0 ? (
        <FDBox alignSelf={'center'}>
          <FDPrimaryActionButton
            size={'sm'}
            label={resource.attr('viewStatementText')}
            icon={'description'}
            iconPosition={'end'}
            onClick={() => {
              addQueryWithReplace({ attachmentSelfLink: accountStatements?.head().link('self').url() });
              setIsPreviewOpen(true);
            }}
          />
          <FileViewer
            attachmentResources={accountStatements?.list()}
            attachmentResource={accountStatements?.head()}
            isOpen={isPreviewOpen}
            closeModal={() => {
              setIsPreviewOpen(false);
            }}
            eventCategory={'Messages'}
          />
        </FDBox>) : null}
      {resource.meta().canDelete() ? (
        <WizardStepDeleteButton
          onDelete={handleDelete}
          onDeleteSuccess={onDeleteSuccess}
          dialogProps={{
            title: 'Are you sure?',
            message: 'Removing this item will delete all of its information. This cannot be undone.',
            confirmLabel: 'Remove',
          }}
        />
      ) : null}

    </PXFormModalWrapper>
  );
};

export default Layout;
